import { SpwkUtil } from "../dao/SpwkUtil";
import { SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { UniForm } from "../dao/UniForm";
import { new_ErrorAlert } from "./ExportManager";
import { SpwkMetaData, SpwkMetaData_DataType } from "./SpwkMetaData";



export class SpwkMetaTable {


  Get檢查時期HisCode(func_code: string) {
    const chapter = SpwkUtil.CHAPTER_檢查時期;
    const code = func_code + "_檢查時期";

    const find_q_meta = this.FindQuestionMeta_ByChapterAndCode(chapter, code);

    if (find_q_meta == null) {
      throw new_ErrorAlert("616514 必須要有檢查時期!!!");
    }

    // 目前先簡單寫個方法轉換對應代碼，就不用美個特作都設定(估計未來代碼也不會改變)
    const his_code = SpwkUtilV3.Get檢查時期HisCode(find_q_meta.rhf_value ?? "");
    return his_code;
  }



  func_guid: string;

  func_code: string;
  form_guid: string;

  base_form: UniForm;
  spwk_form: UniForm;

  meta_rows: SpwkMetaData[] = [];

  constructor(base_form: UniForm, spwk_form: UniForm) {

    if (spwk_form.func_code == null) {
      throw new_ErrorAlert("spwk_form.func_code==null !!!");
    }

    this.func_guid = spwk_form.func_guid;
    this.func_code = spwk_form.func_code;
    this.form_guid = spwk_form.guid;

    this.base_form = base_form;
    this.spwk_form = spwk_form;
  }

  pushMetaData(meta: SpwkMetaData) {
    this.meta_rows.push(meta);
  }

  IsAllSameFuncCode(func_code: string): boolean {
    if (this.meta_rows.length !== 0) {

      let find = this.meta_rows.find(x => x.func_code !== func_code);

      if (find == null) {
        return true;
      } else {
        return false;
      }

    }

    return true;
  }




  /* --- Methods --- */



  /**
   * 依照單選題的答案，找出底下對應的選項的his_code(未填寫則回傳 "")
   * @param q_meta 
   * @returns 
   */
  GetRadioOption_HisCodeBundle(q_meta: SpwkMetaData): {
    his_code: string,
    opt_meta: SpwkMetaData | null
  } {
    let find_opt_meta = this.FindRadioOptionMeta(q_meta);

    if (find_opt_meta == null) {
      return { his_code: "", opt_meta: null };// 未填寫，回傳空字串
    } else {
      if (find_opt_meta.his_code === "") {
        throw new_ErrorAlert("45843 預期要有 his_code !!!\nopt_guid:" + find_opt_meta.data_guid);
      }

      return { his_code: find_opt_meta.his_code, opt_meta: find_opt_meta };
    }
  }



  GetCheckOption_HisCodeAndMetaList_Bundle(q_meta: SpwkMetaData): {
    his_code_list: string[],
    opt_meta_list: SpwkMetaData[]
  } {

    let meta_table: SpwkMetaTable = this;

    let all_opt_meta_list = meta_table.FilterOptions_ByQuestionGuid(q_meta.question_guid);

    if (all_opt_meta_list.length === 0) {
      throw new_ErrorAlert("146413 多選題: 應該要有項目!!!\nq_guid:" + q_meta.question_guid);
    }

    let opt_meta_list: SpwkMetaData[] = []
    let his_code_list: string[] = [];
    for (const opt of all_opt_meta_list) {
      let rhf_value = opt.rhf_value;
      let check = (rhf_value === true);

      if (check) {
        let his_code = opt.his_code;

        if (his_code == null || his_code.trim() === "") {
          throw new_ErrorAlert("勾選選項應該要有 HIS_CODE !!!\nopt_guid:" + opt.data_guid);
        }

        opt_meta_list.push(opt);
        his_code_list.push(his_code);
      }
    }

    return { his_code_list, opt_meta_list };
  }

  /**
   * 依照單選題的答案，找出底下對應的選項(未填寫則回傳 null)
   * @param q_meta 
   * @returns 
   */
  FindRadioOptionMeta(q_meta: SpwkMetaData): SpwkMetaData | null {
    if (q_meta.kind !== SpwkUtilV3.Q_KIND_單選) {
      throw new_ErrorAlert("68473 預期是單選題目!!!\nguid:" + q_meta.data_guid);
    }

    let rhf_value = q_meta.rhf_value;

    if (rhf_value == null || rhf_value === "") {
      return null;
    }

    let opt_meta_list = this.FilterOptions_ByQuestionGuid(q_meta.question_guid);
    let find_opt = opt_meta_list.find(x => x.code === rhf_value);

    if (find_opt == null) {
      throw new_ErrorAlert("預期要有 " + rhf_value + " 的選項，但是找不到!!!\nguid:" + q_meta.data_guid);
    }

    return find_opt;
  }

  /** 撈出所有應該寫入 問卷基本檔.xlsx 的項目 
   * 目前 {...} 包起來的 his_rule 都是基本檔的
  */
  Select_基本檔MetaList() {
    let rslt = this.meta_rows.filter(x => x.IsHisBasicMeta());
    return rslt;
  }




  /** 撈出與指定題目相關的 Inputs (申報用，申報時以一題為單位填入後面的 答題內容_1~4) */
  FilterInputs_ByQuestionGuid(question_guid: string): SpwkMetaData[] {
    const meta_table = this;
    let rslt = meta_table.meta_rows.filter(x =>
      x.question_guid === question_guid &&
      x.data_type === SpwkMetaData_DataType.Input
    );

    return rslt;
  }



  /** 撈出指定題目的選項 (不含 Input) */
  FilterOptions_ByQuestionGuid(question_guid: string): SpwkMetaData[] {
    const meta_table = this;
    let rslt = meta_table.meta_rows.filter(x => x.question_guid === question_guid && x.data_type === SpwkMetaData_DataType.Option);
    return rslt;
  }


  /** 找出 HIS基本檔 對應的 meta_data  
  * (找到 {...} 包圍的 his_code)
  */
  FindMetaData_ByHisColName(his_code: string) {
    const meta_table = this;
    var find = meta_table.meta_rows.find(x => x.his_code === his_code);
    return find;
  }

  /** 撈出指定 chapter 的題目(注意! 已排除 kind=題目)
  * 
  */
  FilterQuestions_ByChapter(chapter: string): SpwkMetaData[] {
    const meta_table = this;
    let rslt = meta_table.meta_rows.filter(x => x.chapter === chapter &&
      x.data_type === SpwkMetaData_DataType.Question &&
      x.kind !== SpwkUtilV3.Q_KIND_標題
    );
    return rslt;
  }

  /**
  * 找出指定章節 指定代碼 的題目
  * 目前僅用在: "檢查時期.檢查時期A01"
  * 不是用GUID比較不准!!
  */
  FindQuestionMeta_ByChapterAndCode(chapter: string, question_code: string) {
    const meta_table = this;
    let find = meta_table.meta_rows.find(x =>
      x.chapter === chapter &&
      x.code === question_code &&
      x.data_type === SpwkMetaData_DataType.Question && x.kind !== SpwkUtilV3.Q_KIND_標題
    );
    return find;
  }

  /** 只撈出指定 Chapter 的選項 (不含題目 和 Input) */
  FilterOptions_ByChapter(chapter: string): SpwkMetaData[] {
    const meta_table = this;
    let rslt = meta_table.meta_rows.filter(x => x.chapter === chapter && x.data_type === SpwkMetaData_DataType.Option);
    return rslt;
  }


  /** 只撈出指定 Chapter 的Input (不含題目 和 Option) */
  FilterInputs_ByChapter(chapter: string): SpwkMetaData[] {
    const meta_table = this;
    // TODO 684616: 問HIS如果有勾選，但是沒填答案要Text嗎?
    let rslt = meta_table.meta_rows.filter(x => x.chapter === chapter && x.data_type === SpwkMetaData_DataType.Input);
    return rslt;
  }

  FilterInputs_ByOptionGuid(option_guid: string) {
    const meta_table = this;
    let rslt = meta_table.meta_rows.filter(x => x.option_guid === option_guid && x.data_type === SpwkMetaData_DataType.Input);
    return rslt;
  }




}